module.exports = __webpack_public_path__ + "static/media/Soybean8R2.507c18be.PNG";